import routerOptions0 from "/data/root-data/TG/lip-sync/master/lip-sync/node_modules/.pnpm/nuxt@3.21.5_@parcel+watcher@2.5.6_@types+node@22.19.19_@vue+compiler-sfc@3.5.34_better-_e3fd2a4e19b437fbd207cf7b4f73ca20/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}